exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#combined-chart[data-v-75798fe4]{\n  width: 1200px;\n  height: 600px;\n}\n#text[data-v-75798fe4] {\n  width: 100%;\n}\n.text[data-v-75798fe4] {\n  padding: 5px 0;\n  width: 100%;\n}\nem[data-v-75798fe4] {\n  font-weight: 500\n}\n\n", ""]);

// exports
